import Slider from '@mui/material/Slider';
import {useField, useFormikContext} from 'formik';
import {notEmpty} from 'main/utility/CommonUtil';
import {getSliderMarks} from 'main/utility/LayoutUtil';
import PropTypes from 'prop-types';
import {useMemo} from 'react';

const AppOptFldSlider = (props) => {
  const {options, step, min, max, multivalue: isMulti} = props;
  const [field] = useField(props);
  const {setFieldValue} = useFormikContext();
  const hasOptions = notEmpty(options);

  const sliderAttributes = useMemo(() => {
    if (hasOptions) {
      const values = options.map((o) => Number(o.value));
      return {
        marks: options.map((o) => ({label: o.label, value: Number(o.value)})),
        step: null,
        min: Math.min(...values),
        max: Math.max(...values),
      };
    }

    // min/max slider
    return {
      marks: getSliderMarks(min, max, step),
      step: step ?? 1,
      min,
      max,
    };
  }, [min, max, step, hasOptions, options]);

  const handleChange = (_, newValue) => {
    setFieldValue(field.name, isMulti ? [...newValue] : Number(newValue));
  };

  return (
    <Slider
      {...field}
      onChange={handleChange}
      valueLabelDisplay='auto'
      {...sliderAttributes}
    />
  );
};

AppOptFldSlider.propTypes = {
  label: PropTypes.string,
  labelid: PropTypes.string,
  required: PropTypes.bool,
  multivalue: PropTypes.bool,
  step: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.any.isRequired,
    }),
  ),
};

export default AppOptFldSlider;
